import React, { Component } from 'react';
import {Row, Col, Container} from 'react-bootstrap';
import '../css/style.css';
import Preloader from '../appshell/Preloader/Preloader';
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css';



class Smokefree extends Component {

	constructor(props) {
		super(props);
		this.state = {spinner: true}
	  
	  }
	  componentDidMount(){
		setTimeout(() => {
			this.setState({ spinner: false });
		  }, 1000);
	  }

    render() {


      return (

        <section>
{this.state.spinner ? <Preloader/> : true}


	  <Row className="hero-section d-flex position-relative align-items-center">
				<Container>
					<Row>
						<div className="col-12 col-md-6 hero-content">

								<img src="./assets/img/smokefree/smokefree-logo.webp" className="project-logo" alt="Smokefree logo"/>
							<h1>Smokefree QuitGuide App</h1>
							<p className="mb-0 mt-4">
								<strong>My Role</strong>: Interaction Designer, React-Native Developer</p>
							<p className="mb-0"><strong>Duration</strong>: 3 Years</p>
							<p><strong>Deliverables</strong>: 	<a className="header-link" href="https://smokefree.gov/" target="_blank" rel="noopener noreferrer">smokefree.gov</a>, <a className="header-link" href="https://smokefree.gov/tools-tips/apps/quitguide" target="_blank" rel="noopener noreferrer">Smokefree QuitGuide App</a></p>


							
							
						</div>
					</Row>
				</Container>

				<div className="col-12 hero-image">
					<div className="hero-image-container">
						<LazyLoadImage 
							effect="blur" 
							src="./assets/img/smokefree/smokefree-header.webp" 
							className="hero-image-cover"
						/>
					</div>
				</div>

		          </Row>





			

		
		<section className="smokefree-bg section information-flow" >
		<Container>
		<Row className="vcenter" >
		   <Col xs={12} md={12}>
			<h2>A mobile app designed for the Smokefree journey.</h2>
			<p>We designed the QuitGuide app to follow the stages of the quitting journey outlined on our website. To emphasize the concept of a journey,
				 we used various metaphors within the app. The main screen of the app features a mountainous background that changes color to reflect the 
				 time of day, helping users connect the quitting journey with their daily lives. The app also includes a milestones-based journey screen 
				 that shows a path to the Smokefree Day and provides an award system to motivate users. This journey serves as the main thread that ties 
				 all the features of the app together, making it easy for users to understand and follow.
			</p>
			<p>By organizing the app around a journey structure, we were able to incorporate all of our existing content and features. One example is the 
				addition of two main call-to-action buttons on the home screen: "I was smokefree today" and "I smoked today." These allow users to track 
				their smokefree status each day and receive personalized challenges, tips, and inspirations based on their progress. The journey is advanced 
				through smokefree days, challenges completed, and tips followed. We also included quitting tutorials and emotion tracking tools to help users 
				monitor and improve their progress.
			</p>
			
			<LazyLoadImage effect="blur" alt="other content type" src="./assets/img/smokefree/information-flow.webp" className="img-fluid image-within-content" />
			</Col>
			
			</Row>
		</Container>

		</section>


		<section className="smokefree-bg section" >
		<Container>
		<Row className="vcenter" >
		   <Col xs={12}>
			<h2>An explanation of the different screens and their specific uses</h2>
			<p>After defining the main user flow, we further defined the specific behaviors and use cases for each screen within the journey. 
				For example, we outlined the initial onboarding screens for the app and identified specific scenarios such as what happens when 
				the user clicks the "smokefree" button within less than a day or how the screen appears at different times of the day. 
				These details may not be included in the overall journey definition, but they are important to consider during the development process.
			</p>
			
			
			</Col>
			<Col xs={12}>
							  <LazyLoadImage effect="blur" alt="UUser Behavior" src="./assets/img/smokefree/user-behavior.webp" className="img-fluid" />
				
			</Col>
			</Row>
		</Container>

		</section>



		<section className="smokefree-bg section" >
		<Container>
		<Row className="vcenter" >
		<Col xs={12}>
		
		</Col>
		   <Col xs={12} md={5}>
							  <h2>Designing the flow for Smokelyzer testing</h2>
			<p>A unique feature of the app is the Smokelyzer testing, which allows users with a Smokelyzer device 
				to connect to the app via Bluetooth and view the testing results. This serves as proof of smokefree 
				days and is currently being tested as an add-on feature. We used illustrated instructions to guide 
				users through the process, which helps emphasize the necessary actions and fits with the overall 
				aesthetic of the app. The process is simplified into three steps to avoid confusion and includes a 
				secondary action for users to take in case of any issues.

			</p>
			
			
			
			</Col>
			<Col xs={12} md={7}>
			 <LazyLoadImage effect="blur" alt="Smokelyzer Screens" src="./assets/img/smokefree/smokelyzer.webp" className="img-fluid" />

			</Col>
			</Row>
		</Container>

		</section>










			  <section className="future-section section" >
		<Container>
		<Row className="vcenter" >
		<Col xs={12}>
		<h2>Possibility of a cross-device platform in the future</h2>
		</Col>
		   <Col xs={12} md={5}>
			
			<p>Possible next steps for further integrating the Smokefree platforms include creating a cross-device 
				platform that allows users to track their progress on any internet-connected device and adding 
				social networking features to promote community support and interaction among users with similar 
				goals. The platform has the potential to become much more than just a website or app in the future, 
				with meaningful conversations and support taking place behind the scenes.
			</p>
			
		
			
			</Col>
			<Col xs={12} md={7}>
							  <LazyLoadImage effect="blur" alt="Smokefree NRT Campaign" src="./assets/img/smokefree/future.webp" className="img-fluid" />

			</Col>
			</Row>
		</Container>

		</section>




    </section>
		
	
      
      )
    }
  }
  
  export default Smokefree;